import React from 'react';
import { X } from 'lucide-react';
import { formatPageNumbers } from '../utils/formatters';

export const ReferenceModal = ({ isOpen, onClose, reference }) => {
  if (!isOpen) return null;

  return (
    <>
      {/* 遮罩层 */}
      <div
        className="fixed inset-0 bg-black/50"
        style={{ zIndex: 999999 }}
        onClick={onClose}  // 添加点击遮罩关闭功能
      />

      {/* 模态框 */}
      <div
        className="fixed inset-0 flex items-center justify-center"
        style={{ zIndex: 1000000 }}
      >
        <div className="bg-white rounded-xl shadow-xl w-full max-w-2xl mx-4 max-h-[90vh] flex flex-col">
          {/* 头部 */}
          <div className="flex items-center justify-between p-4 border-b not-prose">
            <h3 className="text-lg font-medium">引用详情</h3>
            <button
              onClick={onClose}
              className="p-1 hover:bg-gray-100 rounded-lg transition-colors duration-200"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* 内容区 - 添加滚动 */}
          <div className="p-4 overflow-y-auto flex-1">
            <div className="border rounded-lg overflow-hidden">
              <table className="w-full text-sm not-prose">
                <tbody>
                  <tr className="border-b">
                    <td className="bg-gray-50 px-4 py-2 font-medium w-32">文档编号</td>
                    <td className="px-4 py-2">{reference.doc_id}</td>
                  </tr>
                  <tr className="border-b">
                    <td className="bg-gray-50 px-4 py-2 font-medium">文档名称</td>
                    <td className="px-4 py-2">{reference.doc_name}</td>
                  </tr>
                  {formatPageNumbers(reference.page_number) && (
                    <tr className="border-b">
                      <td className="bg-gray-50 px-4 py-2 font-medium">
                        <div className="flex items-center gap-1">
                          所在页码
                          <div className="group relative">
                            <span className="inline-block px-1.5 py-0.5 text-xs bg-gray-100 text-gray-500 rounded cursor-help">
                              ?
                            </span>
                            <div className="hidden group-hover:block absolute left-0 top-6 w-64 p-2 text-xs bg-gray-800 text-white rounded shadow-lg z-10">
                              由于机器读取文件时的渲染格式可能与人类使用办公软件打开时不同，因此页码仅供参考。如发现页码不符，请查看前后几页。
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="px-4 py-2">{formatPageNumbers(reference.page_number)}</td>
                    </tr>
                  )}
                  <tr>
                    <td className="bg-gray-50 px-4 py-2 font-medium">
                      <div className="flex items-center gap-1">
                        引用内容
                        <div className="group relative">
                          <span className="inline-block px-1.5 py-0.5 text-xs bg-gray-100 text-gray-500 rounded cursor-help">
                            ?
                          </span>
                          <div className="hidden group-hover:block absolute left-0 bottom-full mb-2 w-64 p-2 text-xs bg-gray-800 text-white rounded shadow-lg z-20">
                            相关文件由机器直接读取，引用内容的展示格式可能和办公软件打开时不一致。
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-2 whitespace-pre-wrap">{reference.text}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* 底部 */}
          <div className="flex justify-end p-4 border-t">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors duration-200"
            >
              关闭
            </button>
          </div>
        </div>
      </div>
    </>
  );
}; 